import { useQuery } from "@tanstack/react-query"
import { packages } from  '@shared/api/services'

export const useAvaiableTeacherPacks = (teacher) => {
	return useQuery({
		queryKey: ['packs', teacher],
		queryFn: () => packages.getTeacherAvaiablePacks(teacher),
		select: (data) => data.data
})
}